module.exports = __webpack_public_path__ + "img/applicationresults_gj03.20e7a7f7.png";